import { createContext } from 'react'

export const GlobalStateContext = createContext({
	initialized: false,
	setData: () => {},
	isNotFound: false,
	isError: false,
	setError: () => {},
	setNotFound: () => {},
})